export default {"src":"/assets/turbo/cca32f74/ottoversandat/_next/static/media/favicon.7395fa3b.ico","height":32,"width":32,"blurWidth":0,"blurHeight":0};